package com.essntl.core.settings.data.supabase.configuration

import com.essntl.core.settings.domain.model.configuration.ConfigurationCurrencyModel
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonIgnoreUnknownKeys

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@JsonIgnoreUnknownKeys
data class ConfigurationCurrencyDto(
    val allowed: List<String>,
    val default: String,
    @SerialName("cost_default")
    val costDefault: String,
) {
    fun toModel() =
        ConfigurationCurrencyModel(
            allowed = allowed,
            default = default,
            costDefault = costDefault,
        )
}